import { TabsSelectSaleAnalytics } from './TabsSelectSaleAnalytics'

export const ConnectedTabsSelectSaleAnalytics = TabsSelectSaleAnalytics

export { ConnectedTabsSelectSaleAnalytics as TabsSelectSaleAnalytics }
